"use client";

import { IconAvatar } from "@/components/ui/icon-avatar";
import { Icon } from "@/components/ui/icon";
import type { InvitationTokenInfoResponse } from "@/lib/api/model";

interface InviteOrgCardProps {
  invitation: InvitationTokenInfoResponse;
}

export function InviteOrgCard({ invitation }: InviteOrgCardProps) {
  return (
    <div className="flex items-center gap-3 bg-contrast/4 border border-contrast/8 rounded-lg p-3">
      <IconAvatar
        src={invitation.org_logo_url}
        size={36}
        alt={invitation.org_name}
        className="shrink-0 rounded-lg"
        icon={<Icon name="IconBuildings" className="text-heading opacity-40" />}
      />
      <div className="flex flex-col min-w-0">
        <span className="text-sm font-medium text-heading truncate">
          {invitation.org_name}
        </span>
        <span className="text-xs text-contrast/40 truncate">
          {invitation.email}
        </span>
      </div>
    </div>
  );
}
